import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setChatListInitial } from '../../../actions/chatList';
import { increaseCountClosedChats, resetChat } from '../../../actions/chatWindow';
import { selectSubAgent } from '../../../actions/masterFilters';
import { clearOpenedChats } from '../../../actions/openedChats/actions';
import { setSubAgentsSearch } from '../../../actions/subAgents';
import { SubAgentSearchItem } from '../../../components/SubAgentSearchItem';
import { useSubAgentSelectTracking } from '../../../hooks';
import { subAgentsSelector } from '../../../selectors';
import { useApplicationContext } from '../../../utils/applicationContext';

export const useSubAgents = (): React.ReactNode | null => {
  const { subAgentsList } = useSelector(subAgentsSelector);
  const { custom } = useApplicationContext();

  const dispatch = useDispatch();

  const handleTracking = useSubAgentSelectTracking();

  const handleUpdateChats = React.useCallback(() => {
    dispatch(increaseCountClosedChats());
    dispatch(setSubAgentsSearch({ search: '' }));
    dispatch(setChatListInitial());
    dispatch(clearOpenedChats());
    dispatch(resetChat());
    custom.messagesMap.clear();
    // загрузка самих чатов теперь в контейнере
  }, [custom.messagesMap, dispatch]);

  const handleClick = React.useCallback(
    (subAgentId: number) => {
      dispatch(selectSubAgent({ subAgentId }));
      handleUpdateChats();
      handleTracking(subAgentId);
    },
    [dispatch, handleTracking, handleUpdateChats],
  );

  return React.useMemo(() => {
    if (subAgentsList.length) {
      return subAgentsList.map(subAgent => (
        <SubAgentSearchItem key={subAgent.userId} subAgent={subAgent} onClick={handleClick} />
      ));
    }

    return null;
  }, [handleClick, subAgentsList]);
};
